import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'

// แก้ 2026-08-08: เดิม moment.locale('th') ถูกเรียกแค่ใน views/tasks/Tasks.js เป็น
// side-effect ตอน module ถูก evaluate — แต่ทุกหน้าโหลดแบบ React.lazy (แยก chunk ต่อ route)
// ทำให้ locale ภาษาไทยจะถูกตั้งก็ต่อเมื่อผู้ใช้เคยเปิดหน้า Tasks มาก่อนในเซสชันนั้นเท่านั้น
// หน้าอื่น (รายงานทุกหน้า, Issues, Typetasks, User) ที่ format วันที่ด้วย moment เหมือนกัน
// จะได้ชื่อเดือนเป็นภาษาอังกฤษถ้าเข้าหน้านั้นก่อนโดยไม่ผ่าน Tasks — ย้ายมาตั้งที่นี่ (entry
// point เดียวที่รันแน่นอนตอนแอปเริ่ม ก่อน route ไหนๆ ทั้งหมด) แทน เพื่อรับประกันว่า locale
// ภาษาไทยถูกตั้งเสมอไม่ว่าผู้ใช้จะเข้าหน้าไหนก่อน
import moment from 'moment'
import 'moment/locale/th'
moment.locale('th')

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
